import { useEffect } from "react";
import {
  DEFAULT_SCREEN_COLOR,
  LOCAL_STORAGE_SCREEN_COLOR_KEY,
} from "../../../utils/config";

const ScreenColorSetting = ({ screenColor }) => {
  // 背景色の変更をローカルストレージに保存
  useEffect(() => {
    localStorage.setItem(LOCAL_STORAGE_SCREEN_COLOR_KEY, screenColor);
  }, [screenColor]);

  // 背景色を非表示のラジオボタンに設定し、
  // その設定をstyle.cssで読み込んで画面の色を指定している
  return (
    <>
      <input
        type="radio"
        name="screen-color"
        className="d-none screen-color-standard"
        checked={screenColor === "color-standard"}
      />
      <input
        type="radio"
        name="screen-color"
        className="d-none screen-color-black"
        checked={screenColor === "color-black"}
      />
      <input
        type="radio"
        name="screen-color"
        className="d-none screen-color-blue"
        checked={screenColor === "color-blue"}
      />
    </>
  );
};
export default ScreenColorSetting;

// 背景色の初期値、ローカルストレージに背景色の設定があればそれを初期値にする
export const getDefaultScreenColor = () => {
  const color = localStorage.getItem(LOCAL_STORAGE_SCREEN_COLOR_KEY);
  return color ? color : DEFAULT_SCREEN_COLOR;
};
